import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import 'antd/dist/reset.css';
import './index.css';
import App from './App';

// 本番環境でコンソール出力を抑制（console.errorのみ残す）
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.warn = noop;
  // console.error は重大なエラー追跡のため残す
}

// Chrome拡張機能やサードパーティスクリプトのエラーを無視
window.addEventListener('error', event => {
  // chrome-extension:// からのエラーを無視
  if (event.filename && event.filename.startsWith('chrome-extension://')) {
    console.warn('[Ignored] Chrome extension error:', event.message);
    event.preventDefault();
    return;
  }

  // moz-extension:// からのエラーを無視（Firefox）
  if (event.filename && event.filename.startsWith('moz-extension://')) {
    console.warn('[Ignored] Firefox extension error:', event.message);
    event.preventDefault();
    return;
  }

  // safari-web-extension:// からのエラーを無視（Safari）
  if (event.filename && event.filename.startsWith('safari-web-extension://')) {
    console.warn('[Ignored] Safari extension error:', event.message);
    event.preventDefault();
    return;
  }

  // 外部スクリプト（CDN等）からのエラーを無視（オプション）
  // 必要に応じてコメントアウトを外してください
  // if (event.filename && !event.filename.includes(window.location.origin)) {
  //   console.warn('[Ignored] External script error:', event.message);
  //   event.preventDefault();
  //   return;
  // }
});

// Promise rejection エラーも同様に処理
window.addEventListener('unhandledrejection', event => {
  // エラーのスタックトレースから拡張機能を検出
  if (event.reason && event.reason.stack) {
    const stack = event.reason.stack;
    if (
      stack.includes('chrome-extension://') ||
      stack.includes('moz-extension://') ||
      stack.includes('safari-web-extension://')
    ) {
      console.warn('[Ignored] Extension rejection:', event.reason);
      event.preventDefault();
      return;
    }
  }
});

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById('root'),
);
